export const removeNullInArray = (array) => {
  if(array === null) return [];
  if(array === undefined) return [];
  if(array.length === 0) return [];

  return array.filter(function( element ) {
     return (element !== undefined && element !== null);
  });
}
